<div class="errorwrap d-flex">
    <div class="container">
        <div class="col-md-12">
            <div class="error-inner">
                <h3>This page doesn't seem to exist.</h3>
                <h4>It looks like the link pointing here was faulty. Maybe try searching?</h4>

                <form class="search-form-404">
                    <div class="input-group search-box">
                        <input type="search" class="form-control" placeholder="Search" />
                        <div class="input-group-append">
                            <button class="btn btn-search">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                    </div>

                </form>

            </div>
        </div>
    </div>
</div>